import { render, staticRenderFns } from "./work-map.vue?vue&type=template&id=55db8020&scoped=true&"
import script from "./work-map.vue?vue&type=script&lang=js&"
export * from "./work-map.vue?vue&type=script&lang=js&"
import style0 from "./work-map.vue?vue&type=style&index=0&id=55db8020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db8020",
  null
  
)

export default component.exports